<template>
  <router-view />
</template>

<script>
export default {
  name: "reportmanagement",
};
</script>